





























import { defineComponent, getCurrentInstance, ref } from "@vue/composition-api";
import emitter from "@/lib/helpers/emitter";
import { EVENTS } from "@/lib/const";
import { $t } from "@/lib/helpers/i18nHelper";
import { FormField } from "@/types";
import FieldPrinter from "@/components/FieldPrinter";
import providers from "@/lib/providers";

export default defineComponent({
  name: "PageForgotPasswordSet",
  props: {
    email: { type: String, default: "" },
    token: { type: String, default: "" },
  },
  components: { FieldPrinter },
  setup(props) {
    const password = ref("");
    const valid = ref(true);
    const vm = getCurrentInstance();

    emitter.emit(EVENTS.LOADING.CHANGE, false);
    const fieldPassword: FormField = {
      type: "password",
      name: "password",
      title: $t("Password"),
      rules: [v => !!v || $t("Password is required")],
    };

    const submit = async () => {
      if (!password.value) {
        alert($t("Password field is empty"));
        return;
      }
      try {
        emitter.emit(EVENTS.LOADING.CHANGE, true);
        await providers.PasswordResetProvider.change({ data: { password: password.value, token: props.token } });
        vm?.$router.push({ name: "login" });
      } finally {
        emitter.emit(EVENTS.LOADING.CHANGE, false);
      }
    };

    return {
      password,
      valid,
      fieldPassword,
      submit,
    };
  },
});
